module.exports = __webpack_public_path__ + "img/568a97f.png";